"use strict";

var $ = require("jquery");
window.jQuery = $;
window.$ = $;

require("../node_modules/bootstrap/dist/js/bootstrap.js");
require("../node_modules/dotdotdot/src/js/jquery.dotdotdot.min.js");
require("../node_modules/isotope-layout/dist/isotope.pkgd.js");
require("../node_modules/flickity/dist/flickity.pkgd.min.js");
require("../node_modules/angular");

require("./custom/jquery.hoverIntent.min.js");

require("./custom/main.js");
require("./custom/mega-nav.js");
require("./custom/fully-managed.js");
require("./custom/controllers/blogListController.js");


// WEBPACK FOOTER //
// ./cmsscripts/index.js